/**
 * Create Routine Flow
 * 
 * Guides users through creating their first routine.
 * Triggers when the create routine button is clicked for the first time.
 */

import { SquiggleFlow } from '../types';

export const createRoutineFlow: SquiggleFlow = {
  id: 'createRoutine.v1',
  version: 1,
  title: 'Create Your First Routine',
  priority: 70,
  enabledByDefault: true,
  
  gating: {
    oncePerUser: false,
    oncePerSession: true,
    prerequisites: [
      { type: 'hasCompleted', key: 'welcome.v1', equals: true },
    ],
  },
  
  triggers: [
    { type: 'event', name: 'routine:create:opened' },
  ],
  
  steps: [
    {
      id: 'arrive',
      action: { 
        kind: 'moveTo', 
        target: { type: 'viewport', x: 0.2, y: 0.35 },
        arrival: { durationMs: 500, trail: 'draw' }
      },
    },
    {
      id: 'set-excited',
      action: { kind: 'setMood', mood: 'excited' },
    },
    {
      id: 'intro',
      action: {
        kind: 'speak',
        text: "Time to create a routine! Routines help kids know what to expect and build good habits.",
        bubble: { 
          placement: 'right', 
          showDismiss: true,
        },
      },
    },
    {
      id: 'tip-name',
      action: {
        kind: 'speak',
        text: "Give it a fun name like 'Morning Adventure' or 'Bedtime Wind-down'. Kids respond to playful names! 🌟",
        bubble: { 
          placement: 'right', 
          showNext: true,
          showDismiss: true,
        },
      },
    },
    {
      id: 'set-curious',
      action: { kind: 'setMood', mood: 'curious' },
    },
    {
      id: 'tip-times',
      action: {
        kind: 'speak',
        text: "Set a start time and pick which days this routine happens. Consistency is key!",
        bubble: { 
          placement: 'right', 
          showDismiss: true,
        },
      },
    },
    {
      id: 'wait-save',
      action: { 
        kind: 'waitFor', 
        condition: { type: 'event', name: 'routine:created' } 
      },
      timeoutMs: 120000,
      optional: true,
    },
    {
      id: 'celebrate',
      action: { kind: 'gesture', name: 'celebrate' },
    },
    {
      id: 'set-happy',
      action: { kind: 'setMood', mood: 'happy' },
    },
    {
      id: 'congrats',
      action: {
        kind: 'speak',
        text: "Your routine is ready! 🎉 Now add tasks to it by clicking on the routine card.",
        bubble: { 
          placement: 'right', 
          showDismiss: true,
        },
      },
    },
    {
      id: 'wait-dismiss',
      action: { 
        kind: 'waitFor', 
        condition: { type: 'ms', durationMs: 4000 } 
      },
      timeoutMs: 8000,
    },
  ],
  
  onExit: {
    clearTrail: true,
    mood: 'idle',
    returnHome: true,
  },
};

export default createRoutineFlow;
